import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  IDocumentProcessorResponse,
  SignerInput

} from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ApplicationTaxRequestApiService {
  abstract createTaxRequestForms(
    applicationId: string,
    dwellingId: string,
    applicationSgStatus: number,
    approvalTaskId: string,
    approvalTaskItemKey: string,
    signer1: SignerInput,
    signer2: SignerInput,
    email: string,
    envelopeId: string,
    documentId: string,
    attempt:number,
    returnUrl:string,
    isBorrowerAssisted:boolean
  ): Observable<any>;
  abstract get4506cViewUrls(
    applicationId: string,
    approvalTaskId: string,
    dwellingId: string,
    signer1: SignerInput,
    signer2: SignerInput,
    email: string,
    envelopeId: string,
    documentId: string,
    returnUrl:string
  ): Observable<any>;
}
